/**
 * Shared Framer Motion timing constants — the JS-side mirror of the CSS
 * tokens in `packages/ui/src/styles/tokens.css`. Framer Motion transitions
 * can't reference CSS custom properties directly, so components were each
 * hand-typing the same easing curve (and drifting durations) inline instead
 * of sharing one definition. Import these rather than re-declaring a literal.
 */

/** Mirrors `--ease-out-expo`. One-directional motion: entrances, scroll
 *  reveals, content arriving/settling. */
export const EASE_OUT_EXPO = [0.16, 1, 0.3, 1] as const;

/** Mirrors `--ease-in-out-quart`. Symmetric open/close motion — the same
 *  curve drives both directions so a panel's opening and closing read as one
 *  gesture rather than two mismatched ones. */
const EASE_IN_OUT_QUART = [0.76, 0, 0.24, 1] as const;

/** Panel open/close — dropdowns, the mobile drawer, mobile accordions.
 *  Matches the CSS `duration-base` token (300ms) so JS- and CSS-driven
 *  panels move at the same speed. */
export const PANEL_TRANSITION = { duration: 0.3, ease: EASE_IN_OUT_QUART } as const;

/** Scroll-entrance reveals — matches the CSS `duration-slow` token (600ms). */
export const REVEAL_TRANSITION = { duration: 0.6, ease: EASE_OUT_EXPO } as const;
